import React, { useContext, useEffect, useState } from 'react'
import BioMetricTable from './BioMetricTable'
import { FiDownload } from 'react-icons/fi'
import helpers from '../../utils/helpers'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import useToastContext from 'hooks/useToastContext'

const BioMetricTrackModule = () => {
  const { t } = useTranslation()
  const { updatePageName } = useContext(AuthContext)
  const notification = useToastContext()
  const [finalEmployeeList, setFinalEmployeeList] = useState([])
  const [employeeList, setEmployeeList] = useState([])
  const [currentItem, setCurrentItem] = useState('')
  const [isEmployeeList, setIsEmployeeList] = useState(false)

  const [filterData, setFilterData] = useState({
    userIds: '',
    endDate: '',
    category: [],
    searchKey: '',
    startDate: '',
    isReset: false,
    isFilter: false
  })

  const handleView = item => {
    setCurrentItem(item)
    setIsEmployeeList(!isEmployeeList)
  }

  const allEmployeeList = async data => {
    try {
      const { endDate, category, startDate } = filterData
      let newData = []
      category?.map(depart => {
        newData.push(depart?.value)
      })
      const payload = {
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        )
      }
      if (newData.length > 0) payload.employeeIDs = JSON.stringify(newData)
      const path = apiPath.timeSheetList
      const result = await apiGet(path, payload)
      const responseData = result?.data?.results
      const resultStatus = result?.data?.success
      if (resultStatus) {
        notification.success(result?.data.message)
        setEmployeeList(responseData?.docs)
      } else {
        if (newData.length > 0) {
          notification.error(result?.data.message)
        }
      }
    } catch (error) {
      console.log('error in get all employee list==>>>>', error.message)
    }
  }

  const handleDownload = async () => {
    try {
      const { category, startDate, endDate } = filterData
      let newData = []
      category?.map(depart => {
        newData.push(depart?.value)
      })
      const payload = {
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        )
      }
      if (newData.length > 0) payload.employeeIDs = JSON.stringify(newData)
      const resData = await apiGet(apiPath.downloadBiometricAccountant, payload)
      if (resData.data.success) {
        helpers.downloadFile(resData?.data?.results?.file_path)
      } else {
        notification.error(resData?.data.message)
      }
    } catch (error) {
      console.log('error:', error)
    }
  }

  const createEmployeeListOption = item => {
    return {
      label: item?.name,
      value: item?._id
    }
  }

  useEffect(() => {
    allEmployeeList()
  }, [filterData])

  const handleReset = () => {
    setFilterData({
      category: null,
      searchKey: '',
      startDate: '',
      endDate: '',
      userIds: '',
      isReset: true,
      isFilter: false
    })
    // setSearchTerm('')
    setEmployeeList([])
  }

  const handleHREmployeeListResult = result => {
    const { success, results } = helpers.ternaryCondition(
      result?.data,
      result?.data,
      {}
    )
    if (success) {
      const newArray = helpers.ternaryCondition(
        results?.map(createEmployeeListOption),
        results?.map(createEmployeeListOption),
        []
      )
      setFinalEmployeeList(newArray)
    }
  }

  const hrEmployeeList = async () => {
    try {
      const result = await apiGet(apiPath.employeeList)
      handleHREmployeeListResult(result)
    } catch (error) {
      console.error('Error in getting HR employee list:', error.message)
    }
  }

  const handleDateChange = (start, end) => {
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  useEffect(() => {
    updatePageName(t('BIOMETRIC_TRACK_MODULE'))
  }, [])

  useEffect(() => {
    hrEmployeeList()
  }, [])

  const handleEmployee = item => {
    setFilterData({ ...filterData, category: item, isFilter: true })
  }

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <h2 className=' px-4 py-3'>
              <strong>
                Select Employee with start date & end Date to view biometric.
              </strong>
            </h2>
            <form className='gap-2 px-4 py-3 border-b border-b-[#E3E3E3] 2xl:flex '>
              <div className='flex-wrap  items-center mb-2 2xl:mb-0 col-span-2 flex '>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                  <Select
                    isMulti
                    styles={{
                      control: baseStyles => ({
                        ...baseStyles,
                        width: '200px',
                        marginBlockEnd: '10px',
                        padding: '0px 4px',
                        borderRadius: '0.5rem',
                        border: '2px solid rgb(223 223 223);',
                        color: '#000'
                      })
                    }}
                    name='category'
                    value={helpers.orCondition(filterData?.category, null)}
                    options={finalEmployeeList}
                    placeholder={
                      <span
                        style={{ fontSize: '0.875rem' }}
                        className='text-[#A5A5A5]'
                      >
                        {' '}
                        {t('SELECT_EMPLOYEES')}
                      </span>
                    }
                    className='basic-multi-select'
                    classNamePrefix='select'
                    onChange={item => {
                      handleEmployee(item)
                    }}
                  />
                  <ODateRangePicker
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                    handleDateChange={handleDateChange}
                  />
                  <OButton
                    style={{ borderRadius: '0.5rem' }}
                    label='Reset'
                    type='button'
                    onClick={handleReset}
                    extraClasses='ml-3 mb-3'
                  />
                </div>
              </div>
              <div className='justify-end px-4 ms-auto flex items-center mb-3'>
                <button
                  title={t('EXPORT')}
                  className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                  type='button'
                  onClick={e => handleDownload()}
                >
                  <FiDownload className='mr-3' />
                  {t('EXPORT')}
                </button>
              </div>
            </form>
            {employeeList?.length > 0 && (
              <BioMetricTable
                employeeList={employeeList}
                currentItem={currentItem}
                isEmployeeList={isEmployeeList}
                allEmployeeList={allEmployeeList}
                handleView={handleView}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default BioMetricTrackModule
